import {
  faDownLeftAndUpRightToCenter,
  faUpRightAndDownLeftFromCenter,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Delete, OverflowMenu } from '@wfp/icons-react';
import { Text } from '@wfp/react';
import React, { useMemo, useRef } from 'react';
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from 'react-simple-dropdown';

const ReviewIcon = ({
  permissions,
  collapsed,
  closed,
  user,
  activeUser,
  data,
  toggleCollapsed,
  toggleDeleteConfirmationModal,
  isReportPublished,
}) => {
  const dpRef = useRef(null);

  function checkIssueAnotherUserReplies() {
    const { comments } = data || {};
    let hasAnotherUserReplies = false;

    if (comments)
      comments.forEach(item => {
        if (item.user.username !== activeUser) hasAnotherUserReplies = true;
      });

    return hasAnotherUserReplies;
  }

  const { delete_issue, delete_own_issue } = permissions;
  const displayDeleteIcon =
    !closed &&
    ((!!delete_own_issue && user.username === activeUser) || !!delete_issue) &&
    (!checkIssueAnotherUserReplies() || !!delete_issue);
  const deleteIcon = displayDeleteIcon && (
    <Delete fill="#000" id={data.pk} className="noselect" />
  );

  const collapseIcon = useMemo(() => {
    return (
      <FontAwesomeIcon
        icon={
          collapsed
            ? faUpRightAndDownLeftFromCenter
            : faDownLeftAndUpRightToCenter
        }
        className="noselect"
        color="#000"
      />
    );
  }, [collapsed]);

  if (!displayDeleteIcon) return null;

  return (
    <Dropdown ref={dpRef}>
      <DropdownTrigger>
        <OverflowMenu
          width="25"
          height="25"
          className="acr-comment-dropdown-menu"
          color="#000"
        />
      </DropdownTrigger>
      <DropdownContent>
        <div>
          {displayDeleteIcon && !isReportPublished && (
            <div
              onClick={toggleDeleteConfirmationModal}
              className="acr-comments-action"
            >
              <Text>{deleteIcon} Delete Comment</Text>
            </div>
          )}
          {!closed && (
            <div
              onClick={() => {
                dpRef.current.hide();
                toggleCollapsed();
              }}
              className="acr-comments-action"
            >
              <Text>
                {collapseIcon} {collapsed ? 'Expand' : 'Collapse'} Comment
              </Text>
            </div>
          )}
        </div>
      </DropdownContent>
    </Dropdown>
  );
};

export default ReviewIcon;
